import { useQuery } from '@apollo/client'
import { y00tsMutualTokens } from 'apollo/client'
import gql from 'graphql-tag'
import { useMemo } from 'react'
import { notEmpty } from 'utils'

export const QUERY_Y00TS_STATS = gql`
  query records {
    records {
        erc20_token,
        mutual_count,
        token_address,
    }
  }
`

interface y00tsStatsData {
    records: {
        erc20_token: String,
        mutual_count: Number,
        token_address: String,
    }[]
}

/**
 * Fetch matic current price
 */

export function useZettaMutualTokens(): {
    loading: boolean
    error: boolean,
    records: {
        erc20_token: String,
        mutual_count: Number,
        token_address: String,
    }[] | undefined
} {
    const { loading, error, data } = useQuery<y00tsStatsData>(QUERY_Y00TS_STATS, {
        client: y00tsMutualTokens,
        fetchPolicy: 'cache-first',
    })
    const formattedData = useMemo(() => {
        if (data) {
            return data.records
                .map((p) => {
                    return {
                        erc20_token: p.erc20_token,
                        mutual_count: p.mutual_count,
                        token_address: p.token_address,
                    }
                })
                .filter(notEmpty)
        } else {
            return undefined
        }
    }, [data])

    return {
        loading: loading,
        error: Boolean(error),
        records: formattedData,
    }
}
